const TAG_VARIANT_NAME = 'Tag';
const ONLINE_TAG_NAME = 'AVAILABLEONLINE'; // if exist product is available in online
const IN_STORE_TAG_NAME = 'AVAILBLEINSTORE'; // if exist product is available in store
const FILTER_VALUE_LOCATION = 'Locations';
const MAX_FILTERS_TO_SHOW_MOBILE = 5;
const MAX_FILTERS_TO_SHOW_DESKTOP = 5;
const locationsLatLng = {
  800: { lat: 0, lng: 0 }, // Online store always first
  502: { lat: 43.421192453019835, lng: -80.44704781553419 }, // Missing lat lng - Kitchener = 43.421192453019835, -80.44704781553419
  251: { lat: 43.3394, lng: -79.8175 },
  342: { lat: 43.8649045800237, lng: -79.0172813777258 },
  287: { lat: 49.0513569668409, lng: -122.324718689854 },
  291: { lat: 43.226776512799, lng: -79.9501163728207 },
  208: { lat: 44.0057584913509, lng: -79.4460382285153 },
  281: { lat: 45.2697661776439, lng: -79.0172813777258 },
  265: { lat: 44.4119974540365, lng: -79.7107692153013 },
  266: { lat: 43.7689791173624, lng: -79.3867298018236 },
  211: { lat: 43.6714557465776, lng: -79.2939550785125 },
  297: { lat: 43.4048964843612, lng: -80.3276263018323 },
  347: { lat: 43.5102647735428, lng: -79.6301347846383 },
  286: { lat: 49.2739952787163, lng: -122.792759703533 },
  284: { lat: 51.1553213549837, lng: -114.059364130468 },
  322: { lat: 44.7013675601196, lng: -63.5666783018011 },
  210: { lat: 43.6599495114732, lng: -79.5139582018261 },
  325: { lat: 45.929309266862, lng: -66.6641263248086 },
  293: { lat: 55.1737086888524, lng: -118.843099630353 },
  298: { lat: 43.5167945408536, lng: -80.2359364306652 },
  328: { lat: 44.6494140425663, lng: -63.6771698018022 },
  331: { lat: 43.1740253898452, lng: -79.7868649153309 },
  261: { lat: 43.606087128935, lng: -79.652569730663 },
  272: { lat: 45.3080425977745, lng: -75.9119243306217 },
  296: { lat: 49.8238471305073, lng: -97.2020852016693 },
  321: { lat: 49.8979524342666, lng: -97.0635860305029 },
  277: { lat: 44.2577607834546, lng: -76.5676932478389 },
  329: { lat: 48.4395370672486, lng: -123.507871830541 },
  278: { lat: 49.1138752002585, lng: -122.664892530523 },
  316: { lat: 49.7012819140079, lng: -112.824626067289 },
  250: { lat: 43.0184287097603, lng: -81.3124661558144 },
  276: { lat: 42.9348969632577, lng: -81.279619630679 },
  204: { lat: 43.8689858831206, lng: -79.2845450208617 },
  294: { lat: 50.9304929813499, lng: -113.969877330474 },
  326: { lat: 49.9990442513473, lng: -110.647613501664 },
  270: { lat: 43.5379139442472, lng: -79.8741094306646 },
  323: { lat: 46.1179051077884, lng: -64.8233833864236 },
  220: { lat: 43.7048819028851, lng: -79.3885759306607 },
  260: { lat: 44.0738226001667, lng: -79.4831766459941 },
  207: { lat: 43.4832372557234, lng: -79.696115030666 },
  263: { lat: 43.9394846067556, lng: -78.8445120018195 },
  338: { lat: 44.5749124041348, lng: -80.9107636385856 },
  310: { lat: 44.2818826026887, lng: -78.3444067478382 },
  201: { lat: 43.836264812706, lng: -79.0859407018219 },
  312: { lat: 45.4792438562898, lng: -75.5170915441107 },
  314: { lat: 52.1512165926499, lng: -106.619553088112 },
  335: { lat: 53.8909361849002, lng: -122.768220730391 },
  292: { lat: 52.2402907494817, lng: -113.817419601602 },
  311: { lat: 50.4465487151804, lng: -104.542368830488 },
  214: { lat: 43.853706076173, lng: -79.4337035594926 },
  320: { lat: 43.6819328326355, lng: -79.3912675306613 },
  324: { lat: 45.3062411536683, lng: -66.0199765304584 },
  330: { lat: 52.0884252178683, lng: -106.645460778141 },
  280: { lat: 50.9083452142367, lng: -114.065159376327 },
  282: { lat: 53.5425578566758, lng: -113.316222513031 },
  285: { lat: 53.4504254828844, lng: -113.486392899521 },
  313: { lat: 53.6449868592672, lng: -113.627241443693 },
  271: { lat: 43.1325921864043, lng: -79.2251803304968 },
  334: { lat: 47.6191922292226, lng: -52.719102559212 },
  273: { lat: 45.4264272171142, lng: -75.6380183304364 },
  327: { lat: 46.5041364258885, lng: -80.9515247322566 },
  332: { lat: 46.148016043591, lng: -60.143514430417 },
  295: { lat: 53.535211732832, lng: -113.617283230204 },
  315: { lat: 49.0378719129999, lng: -123.087001030336 },
  252: { lat: 43.7881227953426, lng: -79.5453758593154 },
  262: { lat: 43.4843746234384, lng: -80.527021370967 },
  274: { lat: 51.0166414740378, lng: -114.171504730279 },
  290: { lat: 53.4353441118047, lng: -113.603441630207 },
  275: { lat: 42.2732165217601, lng: -83.005516536614 },
  200: { lat: 43.7319947230506, lng: -79.4042549705241 },
};

function loadCartFromAjax() {
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    cache: false,
    success(cart) {
      setTimeout(function () {
        refreshCart(cart);
        if ($('body').hasClass('fancybox-active')) {
          $.fancybox.close();
        }
        if ($('#header').is(':visible')) {
          $('#header .cart-container').addClass('active_link');
        } else if ($('.sticky_nav--stick').length) {
          $('.sticky_nav .cart-container').addClass('active_link');
        } else {
          $('.top-bar .cart-container').addClass('active_link');
        }

        // block scrolling on mobile
        if (window.PXUTheme.media_queries.medium.matches) {
          const $cartContainer = $(this).parent();
          if ($cartContainer.hasClass('active_link')) {
            $('body').addClass('blocked-scroll');
          } else {
            $('body').addClass('blocked-scroll');
          }

          // Scroll to the top of the page unless the header is fixed
          const header = document.getElementById('header');
          if (header.classList.contains('mobile_nav-fixed--false')) {
            window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
          }
        }
      }, 500);
    }
  });
};

function refreshCart(cart) {
  $('.cart_count').empty();
  const $cartBtn = $('.cart_count');
  const value = $cartBtn.text() || '0';
  let cartItemsHTML = '';
  let cartDiscountsHTML = '';
  let cartActionHTML = '';
  let cartSavingsHTML = '';
  const $cartForm = $('[data-cart-form]');
  let productHasSale = false;
  let productCompareAtPrice = 0;
  let productFinalPrice = 0;
  $cartForm.data('total-discount', cart.total_discount);
  $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
  if (cart.item_count === 0) {
    $('.js-empty-cart__message').removeClass('hidden');
    $cartForm.addClass('hidden');
  } else {
    $('.js-empty-cart__message').addClass('hidden');
    $cartForm.removeClass('hidden');
    let totalSaving = 0; // adding counter variables for total cart savings
    let saving = 0;
    $.each(cart.items, (index, item) => {
      const itemDiscounts = item.discounts;
      let discountMessage = '';
      for (let i = 0; i < itemDiscounts.length; i++) {
        const {
          title
        } = itemDiscounts[i];
        discountMessage = `<p class="notification-discount meta">${title}</p>`;
      }
      const lineID = index + 1;
      cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">` + `<a href="${item.url}">`;
      if (item.image) {
        cartItemsHTML += `${'<div class="cart_image">' + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />` + '</div></a>';
      }
      cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;
      if (item.selling_plan_allocation) {
        cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
      }
      if (item.properties) {
        cartItemsHTML += '<div class="mini-cart__item-properties">';
        $.each(item.properties, (title, value) => {
          if (value && value !== 'on' && title && title[0] !== '_') {
            cartItemsHTML += `<div class="mini-cart__item-property">${title}: ${value}</div>`;
          }
        });
        cartItemsHTML += '</div>';
      }
      cartItemsHTML += '</div><div class="mini-cart__item-price">';
      $.ajax({
        dataType: 'json',
        async: false,
        cache: false,
        url: `/products/${item.handle}.js`,
        success(data) {
          let productData = data;
          // If item has more than one variant, need to make sure we are pulling data from the correct variant
          if (productData.variants) {
            const itemVariants = productData.variants;
            if (itemVariants.length > 1) {
              for (let v = 0; v < itemVariants.length; v++) {
                if (itemVariants[v].id === item.id) {
                  productData = itemVariants[v];
                }
              }
            }
          }

          // If compare at price exists then item is on sale
          if (productData.compare_at_price && productData.compare_at_price > productData.price) {
            productHasSale = true;
            productCompareAtPrice = productData.compare_at_price;
            productFinalPrice = productData.price;
          } else {
            // Check required for non-sale items
            productHasSale = false;
          }
        }
      });
      if (productHasSale === true) {
        // puts the slash through the old item price
        const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
        cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

        // Total savings
        saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
        totalSaving = saving + totalSaving;
      } else if (item.price > item.final_price) {
        // puts the slash through the old item price
        const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
        cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
      } else {
        const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
        if (item.price > 0) {
          cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
        } else {
          cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
        }
      }
      cartItemsHTML += '</div>';

      // Unit price

      if (item.unit_price_measurement && item.price > 0) {
        let unitPriceMeasurementReferenceValue = '';
        if (item.unit_price_measurement.reference_value !== 1) {
          unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
        }
        cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
      }
      if (item.price > item.final_price) {
        cartItemsHTML += discountMessage;
      }
      cartItemsHTML += '<div class="product-quantity-box">';
      cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
      cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
      cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
      cartItemsHTML += '</div></div></div>';
      cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
    });
    const cartDiscounts = cart.cart_level_discount_applications;
    for (let i = 0; i < cartDiscounts.length; i++) {
      const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
      const {
        title
      } = cartDiscounts[i];
      cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
      cartDiscountsHTML += '<span class="cart_discounts--price">';
      cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
    }
    cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
    totalSaving += cart.total_discount;
    if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
      cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>` + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
    } else {
      cartSavingsHTML = '';
    }
  }
  $('.js-cart_items').html(cartItemsHTML);
  $('.js-cart_discounts').html(cartDiscountsHTML);
  $('.js-cart_subtotal').html(cartActionHTML);
  $('.js-cart_savings').html(cartSavingsHTML);

  // Converting the currencies
  if (window.PXUTheme.currency.show_multiple_currencies) {
    window.currencyConverter.convertCurrencies();
  }
};

const isProductInStoreSelected = (product, selectedLocation) => {
  if (product.attributes) {
    
    const availableLocations = product.attributes.find((attribute) => attribute[0] === FILTER_VALUE_LOCATION);

    const inStore =
      availableLocations && availableLocations[1]
        ? availableLocations[1].find((l) => l === selectedLocation)
        : false;
    return inStore;
  }
  return false;
};

const isProductInStoreSerp = (product) => {
  if (product.attributes) {
    const tags = product.attributes.find((attribute) => attribute[0] === TAG_VARIANT_NAME);
    const inStore = tags ? tags[1].find((tag) => tag === IN_STORE_TAG_NAME) : false;
    return inStore;
  }
  return false;
};

const isProductInStockSerp = (product) => {
  if (product.attributes) {
    const tags = product.attributes.find((attribute) => attribute[0] === TAG_VARIANT_NAME);

    const isStock = tags
      ? tags[1].find((tag) => tag === ONLINE_TAG_NAME) && !tags[1].find((tag) => tag === 'MAINCAT_TransferOut')
      : false;

    return isStock;
  }

  //console.log(`FS > no att for product id: ${product.id}`);
  return false;
};

async function fsGetSelectedLocation(closestLocation) {
  const selectedLocation = localStorage.getItem("selectedLocation")
  if(!selectedLocation){
    localStorage.setItem("selectedLocation", closestLocation)
  }
  return selectedLocation || closestLocation
}

const addSerpStockInfo = async (product, productEl, closestLocation) => {
  const setElement = (productEl, resEle, resEleHTML) => {
    if (productEl.querySelector('.isp-product-stock-info-container')) {
      //console.log(".isp-product-stock-info-container exists");
      productEl.querySelector('.isp-product-stock-info-container').innerHTML = resEleHTML;
    } else {
      //console.log(".isp-product-stock-info-container doesn't exist");
      resEle.innerHTML = resEleHTML;
      productEl.querySelector('.info-container').appendChild(resEle);
    }
  };
  
  const resEle = document.createElement('div');
  resEle.classList.add('isp-product-stock-info-container');
  let loadingEleHtml,
    resEleHTML = '';

  //loading spinner
  loadingEleHtml = `<div class="label-container store-lbl loading-container">
                    <div class="spinner"></div>
                    <div class="line"></div>
                  	</div>`;
  // loadingEleHtml += `<div class="label-container store-lbl loading-container">
  //                   <div class="spinner"></div>
  //                   <div class="line second"></div>
  //                 	</div>`;
  setElement(productEl, resEle, loadingEleHtml);

  //Stock
  const productStockStatus = isProductInStockSerp(product);
  const inStockCls = productStockStatus ? 'available' : 'not-available';
  const inStockIcon = productStockStatus ? 'store-icon' : 'not-store-icon';
  const inStockText = productStockStatus ? 'Available Online' : 'Sold out online';
  resEleHTML += `<div class="label-container stock-lbl ${inStockCls}"><span class="${inStockIcon}"></span><div class="isp-label isStock">${inStockText}</div></div>`;

  //Store
  //User Location
  let selectedLocation = await fsGetSelectedLocation(closestLocation);
  const productStoreStatus = isProductInStoreSelected(product, selectedLocation);

  const inStoreCls = productStoreStatus ? 'available' : 'not-available';
  const inStoreIcon = productStoreStatus ? 'store-icon' : 'not-store-icon';
  const inStoreText = productStoreStatus ? 'Available at ' : 'Sold out at ';
  const productLinck = productEl.querySelector('.fs-serp-product-title').getAttribute("href")
  resEleHTML += `<div class="label-container store-lbl ${inStoreCls}">
                    <span class="${inStoreIcon}"></span>
                    <div class="isp-label isStore">
                      ${
                        productStoreStatus ? `
                        <span>${inStoreText}</span>
                        <a type="button" class="isp-selected-location-link">${selectedLocation}</a>
                        ` :`
                        <span class="not-available" >${selectedLocation}</a>
                        `
                      }
                      </div>
                  </div>
                   <a class="isp-selected-location-link" href="${productLinck}">Check other stores</a>`;



  setElement(productEl, resEle, resEleHTML);

  const btnEle =
    productEl.querySelector(`button.add-to-cart-button`) || productEl.querySelector(`button.add-to-cart-var-button`);
  const isDisabled = !(productStockStatus || productStoreStatus);
  if (btnEle) {
    btnEle.disabled = isDisabled;
    btnEle.style.backgroundColor = isDisabled ? '#bfc9cc' : '';
    btnEle.style.borderColor = isDisabled ? '#bfc9cc' : '';
    btnEle.style.color = isDisabled ? '#fff' : '';
  } else {
    const isCurrentPagePDP = window.location.href.includes('/products/');
    const btnEle = document.createElement('button');
    btnEle.classList.add('add-to-cart-button');
    btnEle.disabled = isDisabled;
    btnEle.innerHTML = '<span>Sold Out</span>';
    Object.assign(btnEle.style, {
      backgroundColor: '#bfc9cc',
      color: '#fff',
      fontWeight: '700',
      fontSize:
        window.innerWidth >= 786 ? '16px' : window.innerWidth < 481 ? (isCurrentPagePDP ? '10px' : '14px') : '12px',
      width: '100%',
      textAlign: 'center',
      height: '40px',
      border: '1px solid #bfc9cc',
      borderRadius: '50px',
      opacity: '0.5',
      textTransform: 'uppercase',
    });
    productEl.querySelector('.add-to-cart-button-wrapper').appendChild(btnEle);
  }
};

const calculateDistance = (userPosition, storePosition) => {
  function toRadians(value) {
    return (value * 3.14159265) / 180;
  }

  var R = 6371;
  var dLat = 0;
  var dLng = 0;
  var uLat = 0;
  var sLat = 0;
  var distance = 0;
  if (userPosition && userPosition.coords && userPosition.coords.latitude && storePosition && storePosition.lat) {
    dLat = toRadians(userPosition.coords.latitude - storePosition.lat);
    uLat = toRadians(userPosition.coords.latitude);
    sLat = toRadians(storePosition.lat);
  }
  if (userPosition.coords && userPosition.coords.longitude && storePosition && storePosition.lng) {
    dLng = toRadians(userPosition.coords.longitude - storePosition.lng);
  }

  if (dLat && dLng && uLat && sLat) {
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(uLat) * Math.cos(sLat);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    distance = R * c;
  }

  return Number(distance.toFixed(1));
};

const ispSetMobileLocationsDistance = (userPosition) => {
  if (
    document.getElementById('serp-portal') &&
    document.getElementById('serp-portal').shadowRoot &&
    document
      .getElementById('serp-portal')
      .shadowRoot.querySelector('.fs-modal.modal-mobile-filters #fs_filter_locations') &&
    document
      .getElementById('serp-portal')
      .shadowRoot.querySelector('.fs-modal.modal-mobile-filters #fs_filter_locations')
      .querySelectorAll('div.checkbox .filters-option-text').length > 0
  ) {
    var locationsFacet = document
      .getElementById('serp-portal')
      .shadowRoot.querySelector('.fs-modal.modal-mobile-filters #fs_filter_locations');
    var locations = locationsFacet.querySelectorAll('div.checkbox .filters-option-text');
    var locationsArray = Array.prototype.slice.call(locations, 0);

    locationsArray.sort(function (a, b) {
      var aID = 0;
      var bID = 0;

      if (a.textContent.indexOf(a.getAttribute('locationID')) > -1) {
        aID = a.getAttribute('locationID');
      }
      if (b.textContent.indexOf(b.getAttribute('locationID')) > -1) {
        bID = b.getAttribute('locationID');
      }

      var distA = 0;
      var distB = 0;

      if (!aID) {
        if (a.textContent.split(' - ').length > 0 && a.textContent.split(' - ')[0]) {
          aID = a.textContent.split(' - ')[0];
          if (isNumeric(aID) && locationsLatLng[aID]) {
            a.setAttribute('locationID', aID);
            a.textContent = a.textContent.split(' - ')[1] || a.textContent;
            if (userPosition && locationsLatLng && locationsLatLng[aID]) {
              distA = calculateDistance(userPosition, locationsLatLng[aID]);
            }
          }
        }
      }

      if (!bID) {
        if (b.textContent.split(' - ').length > 0 && b.textContent.split(' - ')[0]) {
          bID = b.textContent.split(' - ')[0];
          if (isNumeric(bID) && locationsLatLng[bID]) {
            b.setAttribute('locationID', bID);
            b.textContent = b.textContent.split(' - ')[1] || b.textContent;
            if (userPosition && locationsLatLng && locationsLatLng[aID]) {
              distB = calculateDistance(userPosition, locationsLatLng[bID]);
            }
          }
        }
      }

      if (locationsLatLng[aID] && locationsLatLng[aID].lat !== 0 && !a.textContent.includes('KM ')) {
        a.textContent += ' (' + distA + 'KM From you)';
      }
      if (locationsLatLng[bID] && locationsLatLng[bID].lat !== 0 && !b.textContent.includes('KM ')) {
        b.textContent += ' (' + distB + 'KM From you)';
      }

      let isAshouldBeOnTop =
        a.textContent.toLowerCase() === 'pickup in store' ||
        a.textContent.toLowerCase() === 'online store' ||
        a.closest('.fs-checkbox').classList.contains('fs-selected-checkbox');
      let isBshouldBeOnTop =
        b.textContent.toLowerCase() === 'pickup in store' ||
        b.textContent.toLowerCase() === 'online store' ||
        b.closest('.fs-checkbox').classList.contains('fs-selected-checkbox');

      if (isAshouldBeOnTop && isBshouldBeOnTop) {
        return 0;
      }
      if (isAshouldBeOnTop && !isBshouldBeOnTop) {
        return -1;
      }
      if (!isAshouldBeOnTop && isAshouldBeOnTop) {
        return 1;
      }

      //TODO what if it has km aand then changed?
      return distA - distB;
    });

    if (locationsArray.length === 1 && locationsArray[0] && !locationsArray[0].textContent.includes('KM ')) {
      let el = locationsArray[0];
      let elID = el.textContent.split(' - ')[0];

      if (isNumeric(elID) && locationsLatLng[elID]) {
        el.setAttribute('locationID', elID);
        el.textContent = el.textContent.split(' - ')[1] || el.textContent;
        distEl = calculateDistance(userPosition, locationsLatLng[elID]);
        el.textContent += ' (' + distEl + 'KM From you)';
      }
    }

    //Set location filters order
    locationsArray.forEach(function (locationFilter, i) {
      let newOrder = i;
      if (i >= MAX_FILTERS_TO_SHOW_MOBILE) {
        newOrder = newOrder + 1;
      }
      locationFilter.closest('.category-items > span').style.order = newOrder;
    });
    if (locationsFacet.querySelector('.show-more-button')) {
      let showMoreLess = locationsFacet.querySelector('.show-more-button');
      if (showMoreLess.textContent.toLowerCase().indexOf('less') > -1) {
        showMoreLess.style.order = locationFilter.length + 1;
      }
      showMoreLess.style.order = 1000000; //MAX_FILTERS_TO_SHOW_MOBILE;
    }
  }
};

const ispSetDesktopLocationsDistance = (userPosition) => {
  if (
    document.getElementById('fast-simon-serp-app') &&
    document.getElementById('fast-simon-serp-app').shadowRoot &&
    document
      .getElementById('fast-simon-serp-app')
      .shadowRoot.querySelector('.filters-container #fs_filter_locations') &&
    document
      .getElementById('fast-simon-serp-app')
      .shadowRoot.querySelector('.filters-container #fs_filter_locations')
      .querySelectorAll('div.checkbox .filters-option-text').length > 0
  ) {
    var locationsFacet = document
      .getElementById('fast-simon-serp-app')
      .shadowRoot.querySelector('.filters-container #fs_filter_locations');
    var locations = locationsFacet.querySelectorAll('div.checkbox .filters-option-text');

    //Sort location filters by distance from user
    var locationsArray = Array.prototype.slice.call(locations, 0);
    locationsArray.sort(function (a, b) {
      var aID = 0;
      var bID = 0;

      if (a.textContent.indexOf(a.getAttribute('locationID')) > -1) {
        aID = a.getAttribute('locationID');
      }
      if (b.textContent.indexOf(b.getAttribute('locationID')) > -1) {
        bID = b.getAttribute('locationID');
      }

      var distA = 0;
      var distB = 0;

      if (!aID) {
        if (a.textContent.split(' - ').length > 0 && a.textContent.split(' - ')[0]) {
          aID = a.textContent.split(' - ')[0];
          if (isNumeric(aID) && locationsLatLng[aID]) {
            a.setAttribute('locationID', aID);
            a.textContent = a.textContent.split(' - ')[1] || a.textContent;
            distA = calculateDistance(userPosition, locationsLatLng[aID]);
          }
        }
      }
      if (!bID) {
        if (b.textContent.split(' - ').length > 0 && b.textContent.split(' - ')[0]) {
          bID = b.textContent.split(' - ')[0];
          if (isNumeric(bID) && locationsLatLng[bID]) {
            b.setAttribute('locationID', bID);
            b.textContent = b.textContent.split(' - ')[1] || b.textContent;
            distB = calculateDistance(userPosition, locationsLatLng[bID]);
          }
        }
      }

      if (locationsLatLng[aID] && locationsLatLng[aID].lat !== 0 && !a.textContent.includes('KM ')) {
        a.textContent += ' (' + distA + 'KM From you)';
      }
      if (locationsLatLng[bID] && locationsLatLng[bID].lat !== 0 && !b.textContent.includes('KM ')) {
        b.textContent += ' (' + distB + 'KM From you)';
      }

      let isAshouldBeOnTop =
        a.textContent.toLowerCase() === 'pickup in store' ||
        a.textContent.toLowerCase() === 'online store' ||
        a.closest('.fs-checkbox').classList.contains('fs-selected-checkbox');
      let isBshouldBeOnTop =
        b.textContent.toLowerCase() === 'pickup in store' ||
        b.textContent.toLowerCase() === 'online store' ||
        b.closest('.fs-checkbox').classList.contains('fs-selected-checkbox');

      if (isAshouldBeOnTop && isBshouldBeOnTop) {
        return 0;
      }
      if (isAshouldBeOnTop && !isBshouldBeOnTop) {
        return -1;
      }
      if (!isAshouldBeOnTop && isAshouldBeOnTop) {
        return 1;
      }

      //TODO what if it has km aand then changed?

      return distA - distB;
    });
    if (locationsArray.length === 1 && locationsArray[0] && !locationsArray[0].textContent.includes('KM ')) {
      let el = locationsArray[0];
      let elID = el.textContent.split(' - ')[0];

      if (isNumeric(elID) && locationsLatLng[elID]) {
        el.setAttribute('locationID', elID);
        el.textContent = el.textContent.split(' - ')[1] || el.textContent;
        distEl = calculateDistance(userPosition, locationsLatLng[elID]);
        el.textContent += ' (' + distEl + 'KM From you)';
      }
    }

    //Set location filters order
    locationsArray.forEach(function (locationFilter, i) {
      let newOrder = i;
      if (i >= MAX_FILTERS_TO_SHOW_DESKTOP) {
        newOrder = newOrder + 1;
      }
      locationFilter.closest('.category-items > span').style.order = newOrder;
    });
    if (locationsFacet.querySelector('.show-more-button')) {
      let showMoreLess = locationsFacet.querySelector('.show-more-button');
      if (showMoreLess.textContent.toLowerCase().indexOf('less') > -1) {
        showMoreLess.style.order = locationFilter.length + 1;
      }
      showMoreLess.style.order = 1000000; //MAX_FILTERS_TO_SHOW_DESKTOP;
    }
  }
};

function openLocationsSection(el, event) {
  event.preventDefault();
  event.stopPropagation();

  //mobile menu
  if (
    document.querySelectorAll('#header a.mobile_nav.dropdown_link').length > 0 &&
    document.querySelectorAll('#mobile_menu .change-store-detail').length > 0
  ) {
    document.querySelector('#header a.mobile_nav.dropdown_link').click();
    setTimeout(() => {
      document.querySelector('#mobile_menu .change-store-detail').click();
    }, 0);
  }
  //desktop location section
  else if (document.querySelectorAll('#divTopStoreSection .val-store-name').length > 0) {
    document.querySelector('#divTopStoreSection .val-store-name').click();
  }
}

//get all products elements to loop on
function getProductElements(element) {
  return [...element.querySelectorAll(`.fs-results-product-card`)];
}

function isNumeric(str) {
  if (typeof str != 'string') return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}

//get all products data to loop on
function getProductsData(products, pId) {
  return products[pId];
}

function insertPriceToComparePriceContainer(comparePriceContainerEl, comparePriceEl, priceEl) {
  let priceHtml = priceEl.outerHTML;
  priceHtml = priceHtml.replace(/class="/gi, 'class=" fs-cstm-gap-fix ');

  if (comparePriceContainerEl.querySelectorAll('.fs-cstm-gap-fix').length === 0) {
    comparePriceContainerEl.insertAdjacentHTML('beforeend', priceHtml);
  } else if (comparePriceContainerEl.querySelector('.fs-cstm-gap-fix')) {
    let priceText = priceEl.textContent;
    let cstmPriceText = comparePriceContainerEl.querySelector('.fs-cstm-gap-fix').textContent;
    if (priceText !== cstmPriceText) {
      console.log('FS Debug');
    }
  }
}

function removePriceCurrency(productEl, productData) {
  let priceVal = 0;
  let comparePriceVal = 0;
  let currencyRegex = new RegExp(productData.currency, 'gi');

  if (productEl.querySelector('.price-container .price')) {
    let priceEl = productEl.querySelector('.price-container .price');
    priceVal = priceEl.textContent.replace(currencyRegex, '').trim();
    priceEl.textContent = priceVal;
  }
  if (productEl.querySelector('.compare-container .compare')) {
    let comparePriceContainerEl = productEl.querySelector('.compare-container');
    let comparePriceEl = productEl.querySelector('.compare-container .compare');
    let priceEl = productEl.querySelector('.price-container .price');
    comparePriceVal = comparePriceEl.textContent.replace(currencyRegex, '').trim();
    comparePriceEl.textContent = comparePriceVal;
    /*
    if (priceEl && comparePriceContainerEl && comparePriceEl) {
      insertPriceToComparePriceContainer(comparePriceContainerEl, comparePriceEl, priceEl);
    }
    */
  }
}

function fastsimon_make_noindex() {
  var meta = document.createElement('meta');
  meta.id = 'fastsimon_noindex';
  meta.name = 'robots';
  meta.content = 'noindex,nofollow';
  if (
    document.getElementsByTagName('head').length > 0 &&
    document.getElementsByTagName('head')[0].querySelectorAll('#fastsimon_noindex').length === 0
  ) {
    document.getElementsByTagName('head')[0].appendChild(meta);
  }
}

// function fsAddCstmSearchIconClick() {
//   if (document.querySelector('#header .top_bar .icon-search.fs-first-load-click')) {
//     let searchIcon = document.querySelector('#header .top_bar .icon-search.fs-first-load-click');
//     searchIcon.insertAdjacentHTML(
//       'afterend',
//       '<a onclick="fsHandleCstmSearchIconClick()" class="icon-search dropdown_link__add fs-first-load-click fs-cstm-searc-icon" title="What can we help you find?" data-dropdown-rel="search" mobile-optimized="true"></a>'
//     );
//     searchIcon.classList.add('fs-cstm-hide');
//   }
// }

function fsHandleCstmSearchIconClick() {
  if (
    document.querySelector('.mobile-fast-ac-container') &&
    document.querySelector('.mobile-fast-ac-container').shadowRoot &&
    document
      .querySelector('.mobile-fast-ac-container')
      .shadowRoot.querySelector('#mobile-optimized-container.fs-scroll-search')
  ) {
    let mobileOptimizedContainer = document
      .querySelector('.mobile-fast-ac-container')
      .shadowRoot.querySelector('#mobile-optimized-container.fs-scroll-search');
    let inputOptimized = mobileOptimizedContainer.querySelector('input.fast-autocomplete-input');
    mobileOptimizedContainer.classList.remove('fs-scroll-search');
    inputOptimized.focus();
  }
  if (
    document.querySelector('#header .top_bar .icon-search.fs-first-load-click.fs-cstm-hide:not(.fs-cstm-searc-icon)')
  ) {
    let originalSearchIcon = document.querySelector(
      '#header .top_bar .icon-search.fs-first-load-click:not(.fs-cstm-searc-icon).fs-cstm-hide'
    );
    setTimeout(function () {
      originalSearchIcon.click();
      setTimeout(function () {
        if (
          document.querySelector('.mobile-fast-ac-container') &&
          document.querySelector('.mobile-fast-ac-container').shadowRoot &&
          document
            .querySelector('.mobile-fast-ac-container')
            .shadowRoot.querySelector('#mobile-optimized-container.fs-scroll-search')
        ) {
          let mobileOptimizedContainer = document
            .querySelector('.mobile-fast-ac-container')
            .shadowRoot.querySelector('#mobile-optimized-container.fs-scroll-search');
          let inputOptimized = mobileOptimizedContainer.querySelector('input.fast-autocomplete-input');
          inputOptimized.focus();
        }
      }, 0);
      $('body').addClass('show-search');
    }, 0);
  }
}

function SerpPlpHooks() {
  SerpOptions.registerHook('serp-product-grid', async ({ products, element }) => {
    if(window.location.href.indexOf("book-cat-french-books")>-1)
    {
      //element.classList.add("rle-plp");
    }

    const firstProduct = element?.querySelector('.fs-results-product-card')?.getAttribute('data-product-id')
    const variantId = products?.[firstProduct]?.variants?.[0]?.id
    const response = await fetch(`${window.Shopify.routes.root}variants/${variantId}/?section_id=surface-pick-up`);
    const text = await response.text();
    const resHTML = new DOMParser().parseFromString(text, 'text/html');
    const resHTMLEmbed = resHTML.querySelector('[data-html="surface-pick-up-embed"]').content;
    const availabilityForPicUp = resHTMLEmbed?.querySelector('[data-is-available-for-pic-up]')
    const closestLocation = availabilityForPicUp?.getAttribute('data-closest_location')
    //No Results
    if (element.closest('#fs-serp-page') && element.closest('#fs-serp-page').querySelector('.fs-no-results')) {
      console.log('FS NO RESULTS!');
      fastsimon_make_noindex();
    }

    for (const productElement of getProductElements(element)) {
      //get product data
      const productID = productElement.dataset.productId;
      const productData = getProductsData(products, productID);
      const productSKU = productData && productData.sku ? productData.sku : 0;

      if (productElement && productData) {
        //Remove price cuurency
        removePriceCurrency(productElement, productData);
        // replace badges
        /*replaceBadges(productData, productElement);*/
        //create stock info
        addSerpStockInfo(productData, productElement, closestLocation);
      }

      //gift-cart-hide-yotpo
      var productMainSKUCheckGC = productSKU;
      if (
        productMainSKUCheckGC &&
        productMainSKUCheckGC.indexOf('GC') == 0 &&
        productElement &&
        !productElement.classList.contains('gift-cart-hide-yotpo')
      ) {
        productElement.classList.add('gift-cart-hide-yotpo');
      }
    } //product elements loop END

    // Select all product title elements within the grid
    const productTitles = element.querySelectorAll(".title.fs-product-title");

    productTitles.forEach(titleElement => {

      if (titleElement && titleElement.textContent) {
        const originalTitle = titleElement.textContent.toLowerCase().trim();
        const prefix = "rise little earthling";

        // Check if the title starts with the prefix and update it
        if (originalTitle.startsWith(prefix)) {
            const updatedTitleTemp = originalTitle.replace(prefix, "").trim();

            const words = updatedTitleTemp.split(" ");

            for (let i = 0; i < words.length; i++) {
                words[i] = words[i][0].toUpperCase() + words[i].substr(1);
            }

            updatedTitle = words.join(" ");

            titleElement.textContent = updatedTitle;
        }
      }

    });


  }); //'serp-product-grid' hook END

  SerpOptions.registerHook('serp-filters', ({ filters, element }) => {
    //Add GiftFinder class indicator
    if (
      isGiftFinderPage() &&
      element.closest('#fs-serp-page') &&
      !element.closest('#fs-serp-page').classList.contains('fs-cstm-gift-finder')
    ) {
      element.closest('#fs-serp-page').classList.add('fs-cstm-gift-finder');
    } else if (
      !isGiftFinderPage() &&
      element.closest('#fs-serp-page') &&
      element.closest('#fs-serp-page').classList.contains('fs-cstm-gift-finder')
    ) {
      element.closest('#fs-serp-page').classList.remove('fs-cstm-gift-finder');
    }

    // sort by location
    if (navigator.geolocation) {
      let mobileMaxWidh =
        typeof __fast_options !== 'undefined' &&
        __fast_options.mobileMedieaQuery &&
        __fast_options.mobileMedieaQuery.maxWidth
          ? __fast_options.mobileMedieaQuery.maxWidth
          : 480;
      navigator.geolocation.getCurrentPosition(
        window.innerWidth <= mobileMaxWidh ? ispSetMobileLocationsDistance : ispSetDesktopLocationsDistance
      );
      if (element.querySelector('[id="fs_filter_locations"] .show-more-button')) {
        let showMoreBtnEl = element.querySelector('[id="fs_filter_locations"] .show-more-button');
        showMoreBtnEl.addEventListener('click', function (E) {
          if (navigator.geolocation) {
            let mobileMaxWidh =
              typeof __fast_options !== 'undefined' &&
              __fast_options.mobileMedieaQuery &&
              __fast_options.mobileMedieaQuery.maxWidth
                ? __fast_options.mobileMedieaQuery.maxWidth
                : 480;
            navigator.geolocation.getCurrentPosition(
              window.innerWidth <= mobileMaxWidh ? ispSetMobileLocationsDistance : ispSetDesktopLocationsDistance
            );
          } else {
            console.log('Geolocation is not supported by this browser.');
          }
        });
      }
    } else {
      console.log('Geolocation is not supported by this browser.');
    }

    //Adjust Tag Stock filters
    if (
      element.querySelector(`.category-items input[aria-label="${ONLINE_TAG_NAME}"]`) &&
      element.querySelector(`.category-items input[aria-label="${ONLINE_TAG_NAME}"]`).parentElement &&
      element
        .querySelector(`.category-items input[aria-label="${ONLINE_TAG_NAME}"]`)
        .parentElement.querySelector('.filters-option-text')
    ) {
      element
        .querySelector(`.category-items input[aria-label="${ONLINE_TAG_NAME}"]`)
        .parentElement.querySelector('.filters-option-text').textContent = 'Available Online';
    }
    if (
      element.querySelector(`.category-items input[aria-label="${IN_STORE_TAG_NAME}"]`) &&
      element.querySelector(`.category-items input[aria-label="${IN_STORE_TAG_NAME}"]`).parentElement &&
      element
        .querySelector(`.category-items input[aria-label="${IN_STORE_TAG_NAME}"]`)
        .parentElement.querySelector('.filters-option-text')
    ) {
      element
        .querySelector(`.category-items input[aria-label="${IN_STORE_TAG_NAME}"]`)
        .parentElement.querySelector('.filters-option-text').textContent = 'Available in Stores';
    }
  }); //'serp-filters' hook END
}

// execution here
window.addEventListener('fast-serp-ready', () => SerpPlpHooks());
if (window.SerpOptions) {
  SerpPlpHooks();
}

function removePriceCADcurrency(price) {
  let priceWithoutCurrency = price;
  priceWithoutCurrency = priceWithoutCurrency.replace(/cad/gi, '').trim();
  return priceWithoutCurrency;
}

function AChooks() {
  FastAutocomplete.registerHook('render-autocomplete-product-item', ({ product, index, element }) => {
    let elId = element.getAttribute('data-id');
    let pId = product.id;
    if (elId === pId) {
      if (element.querySelector('.fs-price:not(.compare)')) {
        let elPrice = element.querySelector('.fs-price:not(.compare)');
        let pPrice = product.p ? Number(product.p) : 0;
        elPrice.textContent = `$${pPrice.toFixed(2)}`;
      }
      if (element.querySelector('.fs-price.compare')) {
        let elComparePrice = element.querySelector('.fs-price.compare');
        let pCPrice = product.p_c ? Number(product.p_c) : 0;
        elComparePrice.textContent = `$${pCPrice.toFixed(2)}`;
      }
    }
    let title = element.querySelector('.fs-product-title');
    if(title && title.textContent) {
      // if (title.textContent.includes("Rise Little Earthling ")) {
      //     // Remove the phrase
      //     title.textContent = title.textContent.replace("Rise Little Earthling ", "");
      // }

      const originalTitle = title.textContent.toLowerCase().trim();
      const prefix = "rise little earthling";

      // Check if the title starts with the prefix and update it
      if (originalTitle.startsWith(prefix)) {
        const updatedTitleTemp = originalTitle.replace(prefix, "").trim();

        const words = updatedTitleTemp.split(" ");

        for (let i = 0; i < words.length; i++) {
            words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }

        updatedTitle = words.join(" ");

        title.textContent = updatedTitle;
      }

    }
  }); //hook'render-autocomplete-product-item' END
}

// execution here
if (window.FastAutocomplete) {
  AChooks();
} else {
  window.addEventListener('fast-autocomplete-ready', function () {
    AChooks();
  });
}

function updateFiltersTop(productData) {
  if (document.querySelector('#shopify-section-header #header')) {
    let headerTop = document.querySelector('#shopify-section-header #header').offsetHeight;
    //console.log(productData);
  }
}

const replaceBadges = (productData, productElement) => {
  // Ensure badgeList is defined
  const safeBadgeList = badgeList || {};

  var badges = productData.productBadges?.map((badge) => badge.tag) || [];
  const saleBadgesWrapper = productElement?.querySelector('.fs-badges-wrapper')?.querySelector("[class*='-sale-']");

  if (saleBadgesWrapper) badges.push('Sale');

  const prodTags = productData.tags || [];
  prodTags.forEach((prodTag) => {
    if (Boolean(safeBadgeList[prodTag]) && !badges.includes(prodTag)) {
      badges.push(prodTag);
    }
  });

  const badgeContainer = document.createElement('div');
  badgeContainer.classList.add('serp-badge-container');

  badges.forEach((badge) => {
    const badgeName = safeBadgeList[badge] || badge;
    badgeContainer.innerHTML += `<span class="isp-serp-badge" data-badge-type="${badgeName}">${badgeName}</span>`;
  });

  const existBadgeContainer = productElement
    .querySelector('.fs-badges-wrapper')
    ?.querySelector('.serp-badge-container');

  if (existBadgeContainer) {
    existBadgeContainer.replaceWith(badgeContainer);
  } else {
    productElement.querySelector('.fs-badges-wrapper')?.appendChild(badgeContainer);
  }
};


window.addEventListener('fs-custom-events-filter-clicked', (e) => {
  updateFiltersTop(e);
});

window.addEventListener('fs-custom-events-product-added-to-cart', (e) => {
  loadCartFromAjax();
});

window.addEventListener('fs-custom-events-filter-search-box-changed', (query) => {
  // sort by location
  if (
    navigator.geolocation &&
    document.querySelector('#fast-simon-serp-app') &&
    document.querySelector('#fast-simon-serp-app').shadowRoot &&
    document.querySelector('#fast-simon-serp-app').shadowRoot.querySelector('#fs-serp-page .filters-container')
  ) {
    let element = document
      .querySelector('#fast-simon-serp-app')
      .shadowRoot.querySelector('#fs-serp-page .filters-container');
    let mobileMaxWidh =
      typeof __fast_options !== 'undefined' &&
      __fast_options.mobileMedieaQuery &&
      __fast_options.mobileMedieaQuery.maxWidth
        ? __fast_options.mobileMedieaQuery.maxWidth
        : 480;
    if (navigator && navigator.geolocation && typeof navigator.geolocation.getCurrentPosition === 'function') {
      navigator.geolocation.getCurrentPosition(
        window.innerWidth <= mobileMaxWidh ? ispSetMobileLocationsDistance : ispSetDesktopLocationsDistance
      );
    }
    /*
            if (element.querySelector('[id="fs_filter_locations"] .show-more-button')) {
				let showMoreBtnEl = element.querySelector('[id="fs_filter_locations"] .show-more-button');
				showMoreBtnEl.addEventListener("click", function (E) {
					if (navigator.geolocation) {
						let mobileMaxWidh =	typeof __fast_options !== "undefined" && __fast_options.mobileMedieaQuery && __fast_options.mobileMedieaQuery.maxWidth ? __fast_options.mobileMedieaQuery.maxWidth : 480;
						navigator.geolocation.getCurrentPosition( window.innerWidth <= mobileMaxWidh ? ispSetMobileLocationsDistance : ispSetDesktopLocationsDistance);
					} 
                    else {
						console.log("Geolocation is not supported by this browser.");
					}
				});
			}
            */
  } else {
    console.log('Geolocation is not supported by this browser.');
  }
});
const delay = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
